import React, { Component } from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tr from "date-fns/locale/tr";
import $ from "jquery";
import {
  clearPaymentList,
  getPaymentList,
  deletePayment,
  getActiveMemberNumber,
} from "../../../state/ducks/payment";
import { selectPayment } from "../../../state/ducks/payment/selectors";
import { PaymentDetail } from "./PaymentDetail";
import EminevimLoading from "../shared/EminevimLoading";
import AppCustomSelect from "../shared/AppCustomSelect";

const createDefaultDates = () => {
  const today = new Date();
  const startDate = new Date(today);
  startDate.setMonth(startDate.getMonth() - 1);
  return {
    startDate,
    endDate: new Date(today),
  };
};

const validatePaymentFilter = ({ memberNo, startDate, endDate }) => {
  const errors = {};

  if (!memberNo || memberNo === "0") {
    errors.memberNo = "Üye numarasını seçmelisiniz.";
  }

  if (!startDate) {
    errors.startDate = "Başlangıç tarihi boş bırakılamaz.";
  }

  if (!endDate) {
    errors.endDate = "Bitiş tarihi boş bırakılamaz.";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export class ListPayments extends Component {
  state = {
    ...createDefaultDates(),
    memberNo: "0",
    currentPaymentDetail: {},
    formErrors: {},
    hasSearched: false,
    shouldAnimateCard: false,
    isLoadingList: false,
    showDetailModal: false,
    showCancelModal: false,
  };

  componentDidMount() {
    this.props.clearPaymentList();
    this.props.getMemberNumber();
    $(".react-datepicker-wrapper").addClass("form-control");
    this.setState({ shouldAnimateCard: true });
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }

  handleStartDateChange = (date) => {
    this.setState({
      startDate: date,
      formErrors: { ...this.state.formErrors, startDate: "" },
    });
  };

  handleEndDateChange = (date) => {
    this.setState({
      endDate: date,
      formErrors: { ...this.state.formErrors, endDate: "" },
    });
  };

  handleMemberNoChange = (nextValue) => {
    this.setState({
      memberNo: nextValue,
      formErrors: { ...this.state.formErrors, memberNo: "" },
    });
  };

  getPaymentList = () => {
    const { memberNo, startDate, endDate } = this.state;
    const validation = validatePaymentFilter({ memberNo, startDate, endDate });

    if (!validation.isValid) {
      this.setState({ formErrors: validation.errors });
      return;
    }

    this.props.clearPaymentList();
    this.setState({ hasSearched: true, formErrors: {}, isLoadingList: true });

    this.props
      .getPaymentList(
        memberNo,
        startDate.toLocaleDateString("tr-TR"),
        endDate.toLocaleDateString("tr-TR")
      )
      .finally(() => {
        this.setState({ isLoadingList: false });
      });
  };

  openPaymentDetail = (item) => {
    this.setState({
      currentPaymentDetail: item,
      showDetailModal: true,
    });
  };

  closePaymentDetail = () => {
    this.setState({ showDetailModal: false });
  };

  openCancelModal = (item) => {
    this.setState({
      currentPaymentDetail: {
        memberNo: item.uyeNo,
        paymentId: item.paymentSubscriptionID,
        startDate: item.startDate,
        isPayforPayment: item.isPayforPayment,
        uyeNo: item.uyeNo,
      },
      showCancelModal: true,
    });
  };

  closeCancelModal = () => {
    this.setState({ showCancelModal: false });
  };

  cancelPayment = () => {
    const { currentPaymentDetail, startDate, endDate } = this.state;

    this.setState({ showCancelModal: false, isLoadingList: true });

    this.props
      .deletePayment(
        currentPaymentDetail.memberNo,
        currentPaymentDetail.paymentId,
        currentPaymentDetail.startDate,
        startDate.toLocaleDateString("tr-TR"),
        endDate.toLocaleDateString("tr-TR"),
        currentPaymentDetail.isPayforPayment
      )
      .finally(() => {
        this.setState({ isLoadingList: false });
      });
  };

  getStatusClassName = (status) => {
    const normalized = status;

    if (
      normalized.includes("iptal") ||
      normalized.includes("pasif") ||
      normalized.includes("Başarısız İade") ||
      normalized.includes("Başarısız Ödeme") ||
      normalized.includes("failed")
    ) {
      return "t-listPayments-status t-listPayments-status--danger";
    }

    if (normalized.includes("bekl") || normalized.includes("bekleyen")) {
      return "t-listPayments-status t-listPayments-status--warn";
    }

    return "t-listPayments-status t-listPayments-status--success";
  };

  renderFilterField = (label, error, children) => (
    <div className="t-resetPassword-field t-listPayments-filterField">
      <span className="t-resetPassword-label">{label}</span>
      {children}
      {error ? <div className="t-resetPassword-error">{error}</div> : null}
    </div>
  );

  renderFilterForm = () => {
    const { payment } = this.props;
    const { startDate, endDate, memberNo, formErrors } = this.state;

    return (
      <div className="t-listPayments-filterGrid">
        {this.renderFilterField(
          "Başlangıç Tarihi",
          formErrors.startDate,
          <div className="t-myDemands-dateField m-takvim">
            <div className="input-group">
              <div
                className="input-group-prepend"
                onClick={() => $(".t-listPayments-dateStart").focus()}
              >
                <span className="input-group-text m-takvimiconhizalama">
                  <i className="t-icon-calendar1" aria-hidden="true" />
                </span>
              </div>
              <DatePicker
                id="baslangicTarih"
                className="t-listPayments-dateStart m-datepicker"
                selected={startDate}
                dateFormat="dd.MM.yyyy"
                locale={tr}
                maxDate={endDate}
                placeholderText="Başlangıç tarihi"
                onChange={this.handleStartDateChange}
              />
            </div>
          </div>
        )}

        {this.renderFilterField(
          "Bitiş Tarihi",
          formErrors.endDate,
          <div className="t-myDemands-dateField m-takvim">
            <div className="input-group">
              <div
                className="input-group-prepend"
                onClick={() => $(".t-listPayments-dateEnd").focus()}
              >
                <span className="input-group-text m-takvimiconhizalama">
                  <i className="t-icon-calendar1" aria-hidden="true" />
                </span>
              </div>
              <DatePicker
                id="bitisTarih"
                className="t-listPayments-dateEnd m-datepicker"
                selected={endDate}
                dateFormat="dd.MM.yyyy"
                locale={tr}
                minDate={startDate}
                placeholderText="Bitiş tarihi"
                onChange={this.handleEndDateChange}
              />
            </div>
          </div>
        )}

        {this.renderFilterField(
          "Üye Numarası",
          formErrors.memberNo,
          <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap">
            <span className="t-resetPassword-inputIcon" aria-hidden="true">
              <i className="t-icon-user1" />
            </span>
            <AppCustomSelect
              id="uyeno"
              value={memberNo}
              placeholder="Üye numarası seçiniz"
              options={[
                { value: "0", label: "Üye numarası seçiniz" },
                ...(payment?.paymentActiveMemberNumbers?.map((item) => ({
                  value: String(item.id),
                  label: item.adi,
                })) || []),
              ]}
              onChange={this.handleMemberNoChange}
            />
          </div>
        )}

        <div className="t-listPayments-filterAction">
          <button
            type="button"
            className="t-memberInfo-btn t-memberInfo-btn--primary"
            onClick={this.getPaymentList}
            disabled={this.state.isLoadingList}
          >
            <span>Talimatları Getir</span>
            <i className="t-icon-arrow-right2" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  };

  renderDesktopTable = (payments) => (
    <div className="t-listPayments-tableWrap">
      <table className="t-listPayments-table">
        <thead>
          <tr>
            <th scope="col">Üyelik No</th>
            <th scope="col">Açılma Tarihi</th>
            <th scope="col">Talimat Tarihi</th>
            <th scope="col">Durum</th>
            <th scope="col" className="t-listPayments-detailColumn">
              İşlemler
            </th>
          </tr>
        </thead>
        <tbody>
          {payments.map((item, index) => (
            <tr key={`${item.paymentSubscriptionID}_${index}`}>
              <td data-label="Üyelik No">{item.uyeNo || "-"}</td>
              <td data-label="Açılma Tarihi">{item.createDate || "-"}</td>
              <td data-label="Talimat Tarihi">{item.startDate || "-"}</td>
              <td data-label="Durum">
                <span className={this.getStatusClassName(item.status)}>{item.status || "-"}</span>
              </td>
              <td data-label="İşlemler" className="t-listPayments-actionsCell">
                <button
                  type="button"
                  className="t-memberInfo-btn t-memberInfo-btn--secondary t-listPayments-actionBtn"
                  onClick={() => this.openPaymentDetail(item)}
                >
                  <span>Detay</span>
                  <i className="t-icon-arrow-right2" aria-hidden="true" />
                </button>
                {item.btnVisible === true && (
                  <button
                    type="button"
                    className="t-memberInfo-btn t-memberInfo-btn--secondary t-listPayments-actionBtn t-listPayments-actionBtn--danger"
                    onClick={() => this.openCancelModal(item)}
                  >
                    <i className="t-icon-cancel-circle" aria-hidden="true" />
                    <span>İptal Et</span>
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  renderMobileCards = (payments) => (
    <div className="t-myDemands-mobileList">
      {payments.map((item, index) => (
        <article className="t-myDemands-mobileCard" key={`${item.paymentSubscriptionID}_${index}`}>
          <div className="t-myDemands-mobileField">
            <span className="t-myDemands-mobileLabel">Üyelik No</span>
            <span className="t-myDemands-mobileValue">{item.uyeNo || "-"}</span>
          </div>
          <div className="t-myDemands-mobileField">
            <span className="t-myDemands-mobileLabel">Açılma Tarihi</span>
            <span className="t-myDemands-mobileValue">{item.createDate || "-"}</span>
          </div>
          <div className="t-myDemands-mobileField">
            <span className="t-myDemands-mobileLabel">Talimat Tarihi</span>
            <span className="t-myDemands-mobileValue">{item.startDate || "-"}</span>
          </div>
          <div className="t-myDemands-mobileField">
            <span className="t-myDemands-mobileLabel">Durum</span>
            <span className={this.getStatusClassName(item.status)}>{item.status || "-"}</span>
          </div>
          <div className="t-myDemands-mobileActions t-listPayments-mobileActions">
            <button
              type="button"
              className="t-memberInfo-btn t-memberInfo-btn--secondary t-listPayments-actionBtn"
              onClick={() => this.openPaymentDetail(item)}
            >
              <span>Detay</span>
              <i className="t-icon-arrow-right2" aria-hidden="true" />
            </button>
            {item.btnVisible === true && (
              <button
                type="button"
                className="t-memberInfo-btn t-memberInfo-btn--secondary t-listPayments-actionBtn t-listPayments-actionBtn--danger"
                onClick={() => this.openCancelModal(item)}
              >
                <i className="t-icon-cancel-circle" aria-hidden="true" />
                <span>İptal Et</span>
              </button>
            )}
          </div>
        </article>
      ))}
    </div>
  );

  renderDetailModal = () => {
    if (!this.state.showDetailModal) return null;

    const { currentPaymentDetail } = this.state;

    return (
      <>
        <div
          className="modal fade show t-demandDetailModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="paymentDetailTitle"
          aria-modal="true"
          style={{ display: "block", zIndex: 1055 }}
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content t-guarantorModal-content border-0">
              <div className="t-guarantorModal-header">
                <div className="t-guarantorModal-header-content">
                  <div className="t-guarantorModal-icon">
                    <i className="t-icon-wallet" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="t-guarantorModal-title" id="paymentDetailTitle">
                      Ödeme Talimatı Detayı
                    </h5>
                    <p className="t-guarantorModal-subtitle">
                      Üyelik No: <strong>{currentPaymentDetail.uyeNo || "-"}</strong>
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  className="t-guarantorModal-close"
                  onClick={this.closePaymentDetail}
                  aria-label="Kapat"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="t-guarantorModal-body t-demandDetailModal-body">
                <PaymentDetail detail={currentPaymentDetail} />
              </div>

              <div className="t-guarantorModal-footer">
                <button
                  type="button"
                  className="t-memberInfo-btn t-memberInfo-btn--secondary"
                  onClick={this.closePaymentDetail}
                >
                  <span>Kapat</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
      </>
    );
  };

  renderCancelModal = () => {
    if (!this.state.showCancelModal) return null;

    return (
      <>
        <div
          className="modal fade show t-guarantorModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="paymentCancelTitle"
          aria-modal="true"
          style={{ display: "block", zIndex: 1055 }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content t-guarantorModal-content border-0">
              <div className="t-guarantorModal-header">
                <div className="t-guarantorModal-header-content">
                  <div className="t-guarantorModal-icon">
                    <i className="t-icon-cancel-circle" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="t-guarantorModal-title" id="paymentCancelTitle">
                      Talimat İptali
                    </h5>
                    <p className="t-guarantorModal-subtitle">
                      Üyelik No: <strong>{this.state.currentPaymentDetail.uyeNo || "-"}</strong>
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  className="t-guarantorModal-close"
                  onClick={this.closeCancelModal}
                  aria-label="Kapat"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="t-guarantorModal-confirmBody">
                <p>Bu ödeme talimatını iptal etmek istediğinizden emin misiniz?</p>
              </div>

              <div className="t-guarantorModal-footer">
                <button
                  type="button"
                  className="t-guarantorModal-cancel"
                  onClick={this.closeCancelModal}
                >
                  Vazgeç
                </button>
                <button
                  type="button"
                  className="t-guarantorModal-deleteBtn"
                  onClick={this.cancelPayment}
                >
                  Evet, İptal Et
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
      </>
    );
  };

  renderResults = (payments) => {
    if (this.state.isLoadingList) {
      return (
        <div className="t-listPayments-loading">
          <EminevimLoading subtext="Ödeme talimatlarınız hazırlanıyor, lütfen bekleyiniz." />
        </div>
      );
    }

    if (payments.length === 0) {
      return (
        <div className="t-memberInfo-emptyFilter">
          {this.state.hasSearched
            ? "Seçilen kriterlere uygun ödeme talimatı bulunamadı."
            : "Tarih aralığı ve üye numarasını seçerek talimatları getirebilirsiniz."}
        </div>
      );
    }

    return (
      <>
        <div className="t-listPayments-summary">
          <strong>{payments.length}</strong> talimat listeleniyor
        </div>
        <div className="t-myDemands-desktopOnly">{this.renderDesktopTable(payments)}</div>
        <div className="t-myDemands-mobileOnly">{this.renderMobileCards(payments)}</div>
      </>
    );
  };

  render() {
    const { payment } = this.props;
    const { shouldAnimateCard } = this.state;
    const payments = payment?.paymentList || [];

    return (
      <div style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Ödeme Talimatlarım</h1>
              <p className="t-memberInfo-pageSubtitle">
                Tarih aralığı ve üye numarasına göre ödeme talimatlarınızı görüntüleyin, detayları inceleyin veya iptal edin.
              </p>
            </div>

            <article
              className={`t-memberInfo-card t-memberDetail-header--blue${
                shouldAnimateCard ? " t-memberInfo-card--enter" : ""
              }`}
            >
             

              {this.renderFilterForm()}
              {this.renderResults(payments)}
            </article>
          </div>
        </div>

        {this.renderDetailModal()}
        {this.renderCancelModal()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    payment: selectPayment(state),
  };
}

const mapDispatchToProps = (dispatch) => ({
  getMemberNumber: () => dispatch(getActiveMemberNumber()),
  getPaymentList: (memberNo, startDate, endDate) =>
    dispatch(getPaymentList(memberNo, startDate, endDate)),
  clearPaymentList: () => dispatch(clearPaymentList()),
  deletePayment: (memberNo, paymentId, itemStartDate, startDate, endDate, isPayforPayment) =>
    dispatch(
      deletePayment(memberNo, paymentId, itemStartDate, startDate, endDate, isPayforPayment)
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListPayments);
